import type { RouteRecordRaw } from 'vue-router'

import { routeCompanyRoot } from '@/routers/routes/mainRoutes/routeSettings/companyRoutes.ts'
import { routeDataImportRoot } from '@/routers/routes/mainRoutes/routeSettings/dataImportRoutes.ts'
import { routePrintDesignerRoot } from '@/routers/routes/mainRoutes/routeSettings/printDesignerRoutes.ts'
import { routePrintFormatRoot } from '@/routers/routes/mainRoutes/routeSettings/printFormatRoutes.ts'
import { routeAutomationRoot } from '@/routers/routes/mainRoutes/routeSettings/routeAutomation'
import { routeInterfacesRoot } from '@/routers/routes/mainRoutes/routeSettings/routeInterfaces'
import { routeTagRoot } from '@/routers/routes/mainRoutes/routeSettings/tagsRoutes.ts'

import { routeLetterheadRoot } from './letterheadRoutes'
import { routeNamingSettingsRoot } from './namingSettingsRoutes'
import { routeAccountingSettingsRoot } from './routeAccounting'
import { routeBRMSettingsRoot } from './routeBRM'
import { routeEmailSettingsRoot } from './routeEmail'
import { routeSalesSettingsRoot } from './routeSales'
import { routeSystemSettingsRoot } from './systemSettingsRoutes'
import { routeTermsAndConditionsSettingsRoot } from './termsAndConditionsSettingRoutes'
import { routeUsersHome, routeUsersRoot } from './usersRoutes'

const routeSettingsHome: RouteRecordRaw = {
  name: 'settings-home',
  path: '',
  // TODO: handles url query here via redirect: (to: RouteLocation) => RouteLocationRaw function
  redirect: routeUsersHome,
}

const routeSettingsRoot: RouteRecordRaw = {
  children: [
    routeSettingsHome,
    routeSystemSettingsRoot, // evtl nicht verwendet
    routeUsersRoot,
    routeDataImportRoot,
    routeBRMSettingsRoot,
    routeAccountingSettingsRoot,
    routeLetterheadRoot,
    routeNamingSettingsRoot,
    routeTermsAndConditionsSettingsRoot,
    routePrintFormatRoot,
    routePrintDesignerRoot,
    routeTagRoot,
    routeAutomationRoot,
    routeEmailSettingsRoot,
    routeSalesSettingsRoot,
    routeInterfacesRoot,
    routeCompanyRoot,
  ],
  path: 'settings',
}

export { routeSettingsHome, routeSettingsRoot }
